import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, Calendar } from "lucide-react";
import { useLocation } from "@/contexts/LocationContext";

export function FloatingContactBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [isNearFooter, setIsNearFooter] = useState(false);
  const { location, isSeattle } = useLocation();
  const basePath = isSeattle ? "/seattle" : "";

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      setIsVisible(scrollY > 300);
      setIsNearFooter(scrollY + windowHeight > documentHeight - 200);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible || isNearFooter) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden animate-fade-in">
      <div className="bg-card/95 backdrop-blur-md border-t border-border/50 px-4 py-3 shadow-lg">
        {/* Call-first: a phone call is the highest-converting action for local care,
            so it's the primary button with the number shown; tour is secondary. */}
        <div className="flex items-center gap-2.5">
          <a
            href={`tel:${location.primaryPhone.replace(/-/g, '')}`}
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-accent px-5 py-3.5 text-sm font-semibold text-accent-foreground shadow-md transition-transform active:scale-[0.98]"
          >
            <Phone className="h-[1.125rem] w-[1.125rem]" />
            Call {location.primaryPhone}
          </a>
          <Link
            to={`${basePath}/contact#tour-form`}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-primary/25 bg-primary/5 px-4 py-3.5 text-sm font-semibold text-primary transition-colors hover:bg-primary/10"
            aria-label={isSeattle ? "Join the waitlist" : "Schedule a private tour"}
          >
            <Calendar className="h-4 w-4" />
            {isSeattle ? "Waitlist" : "Tour"}
          </Link>
        </div>
      </div>
    </div>
  );
}
